module.exports = __webpack_public_path__ + "media/icons/firma-active-4fe509c4.png";